import "./styles.less";
import { Skeleton, Space, Tag } from "antd";
import { UseListingTypeTag } from "./ListingType.hook";

export function ListingTypeTag({ id }: { id: string }) {
	const { tags, loading, error } = UseListingTypeTag({ id });

	if (loading) {
		return (
			<Space>
				<Skeleton.Button size={"small"} style={{ width: "70px" }} />
				<Skeleton.Button size={"small"} style={{ width: "70px" }} />
			</Space>
		);
	}

	if (!tags.length || error) return null;

	return (
		<>
			{tags.map((tag, i) => {
				return (
					<Tag
						color={"default"}
						key={"property_" + id + "_tag_" + i}
						className="property-tag">
						{tag.text}
					</Tag>
				);
			})}
		</>
	);
}
